export default __webpack_public_path__ + "static/media/doneMarkInCircle.d2ba2549.svg";